import { usePersonInfo } from '@/data/Content/PersonInfo';
import { useUser } from '@/data/User';

const GENDER_BY_HCL: Record<string, string> = { Male: 'Hombre', Female: 'Mujer' };

export const usePersonalGender = () => {
	const { user } = useUser();
	const { personInfo } = usePersonInfo(!!user?.isLoggedIn);
	return personInfo?.gender ? GENDER_BY_HCL[personInfo.gender] : undefined;
};
